import { useEffect } from 'react';
import OnechipsService from 'services/onechips/Onechips';
import { useSnackbar } from 'notistack';
import PlanInstallAction from 'modules/modals/PlanDetails/components/PlanInstallAction';
import { useParams } from 'react-router';
import { useModal } from 'components/shared/modal';
import useJobProgressLoader from 'hooks/useJobProgressLoader';
import { useTranslation } from 'react-i18next';
import { JobProgressStatus } from 'const/JobProgress';

export const PlanInstall = ({ filters, onFinish = () => {}, modal }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const { eid } = useParams();

  const { start, Loader } = useJobProgressLoader(OnechipsService.planChange, {
    onComplete: (result) => {
      if (result.isWarning) {
        onFinish();
        modal.closeModal();
        return;
      }
      if (result.status === JobProgressStatus.Partially_Finished) {
        enqueueSnackbar(result.data.infoData, { variant: 'warning' });
        onFinish();
      } else if (result.status === JobProgressStatus.Finished) {
        enqueueSnackbar('App install is in progress', { variant: 'success' });
        onFinish();
      } else {
        const { message } = {
          message: result?.error?.message ?? 'App install could not be started',
        };
        enqueueSnackbar(message, { variant: 'error' });
        onFinish();
      }
      modal.closeModal();
    },
  });

  useEffect(() => {
    start({
      ...filters,
      eid,
    });
  }, []);

  return <Loader size={84} />;
};

export const PlanInstallActionContainer = ({ data, queryFilters = {}, onComplete }) => {
  const modal = useModal({ stacked: false });

  const handleOnInstall = (filters) => {
    modal.openModal(PlanInstall, {
      filters,
      onFinish: onComplete,
    });
  };

  return <PlanInstallAction queryFilters={queryFilters} data={data} openInstallModal={handleOnInstall} />;
};

export default PlanInstallActionContainer;
